module.exports = __webpack_public_path__ + "static/media/mem1.c643cd46.webp";